import React from 'react';

function Home() {
  return (
    <div className="App">
      <main className="main-content">
        <div className="content-wrapper">
          <h1>Hey, I'm Ahmed.</h1>
          
          <p className="intro">
            I'm a CS and Math student at Vanderbilt University.
            I'm mostly in Nashville, Beijing or Islamabad (and sometimes sf).
          </p>
          
          <p className="description">
            I'm extremely bullish on urgency and the power of technology to solve problems, that summarizes me in one sentence.
          </p>

          <p className="description">
            My love for the art of building and other shenanigans are on this site.
          </p>

          <p className="description">
            The fastest way to reach me is by email. I am quick to respond there.
          </p>

          <div className="previous-work">
            <h2>Previously:</h2>
            <ul>
              <li><a href="https://farasa.xyz" target="_blank" rel="noopener noreferrer">Farasa</a>: building the biggest dataset in construction robotics</li>
              <li><a href="https://deaflingo.ai" target="_blank" rel="noopener noreferrer">Deaflingo</a>: a sign language learning app using computer vision (200k+ demoers and $50k raised)</li>
              <li>DermaVision: an AI tool that lets you upload a skin image and get a quick diagnosis with a confidence score. It uses a trained neural network to analyze the image and help identify potential skin issues.</li>
              <li>Stempathy: A non-profit organization that is dedicated to providing underprivileged children around the world with access to high-quality STEM resources. Worked with the United Nations and led camps in 4+ countries (raised $100k in donations)</li>
              <li><a href="https://asaanpay.net" target="_blank" rel="noopener noreferrer">AsaanPay</a>: A merchant centric platform built for the millions of small businesses in Pakistan.</li>
              <li><a href="https://acre-robotics.com" target="_blank" rel="noopener noreferrer">Acre Robotics</a>: Helped them build autonomous tractors, pretty fun.</li>
            </ul>
          </div>

          <div className="contact-links">
            <a href="mailto:ahmed.zeeshan@vanderbilt.edu">Email</a> ·
            <a href="https://www.linkedin.com/in/ahmedzeee/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Home;

